module.exports = __webpack_public_path__ + "static/img/4.194917b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/2/zh/4.png
// module id = MPye
// module chunks = 0